export default "__VITE_ASSET__3c67ff1a__"